export default __webpack_public_path__ + "static/media/bg-video-play.283808b4.png";